module.exports = __webpack_public_path__ + "img/02.15521486.jpg";